import { render, staticRenderFns } from "./workplaceStatement.vue?vue&type=template&id=0df9c8e5&scoped=true&"
import script from "./workplaceStatement.vue?vue&type=script&lang=js&"
export * from "./workplaceStatement.vue?vue&type=script&lang=js&"
import style0 from "./workplaceStatement.vue?vue&type=style&index=0&id=0df9c8e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df9c8e5",
  null
  
)

export default component.exports